<script setup lang="ts">
const props = defineProps<{
    noPadding?: boolean;
}>();
</script>

<template>
    <div class="flex flex-col gap-8 w-full" :class="{ 'px-8 py-4': props.noPadding !== true }">
        <slot></slot>
    </div>
</template>
